import { Eye, EyeSlash } from 'iconsax-reactjs';
import { FC, InputHTMLAttributes, useState } from 'react';
import { StyledInput, StyledInputContainer, StyledInputWrapper, StyledTypeSwitch } from './styled';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: string | undefined;
  inputSize?: 'small' | 'medium' | 'large';
}

const Input: FC<Props> = ({ inputSize = 'medium', error, type, ...props }) => {
  const [htmlType, setHtmlType] = useState(type);

  const onSwitchType = () => {
    setHtmlType(htmlType === 'password' ? 'text' : 'password');
  };

  return (
    <StyledInputContainer>
      <StyledInputWrapper>
        <StyledInput $size={inputSize} $password={type === 'password'} type={htmlType} {...props} />
        {type === 'password' && (
          <StyledTypeSwitch type="button" onClick={onSwitchType}>
            {htmlType === 'password' ? <EyeSlash size={18} /> : <Eye size={18} />}
          </StyledTypeSwitch>
        )}
      </StyledInputWrapper>
      {!!error && (
        <p>
          {error}
        </p>
      )}
    </StyledInputContainer>
  );
};

export default Input;